itsoftApp.createModule("scrollTo", ["windowResize", "startLoad"], function () {
    const module = this;
    const hash = location.hash;
    const hashElement = hash ? document.querySelector(hash) : null;

    const ResponsiveScroll = function () {
        this.duration = 1;
        this.init();
    };

    /*
     * Высота шапки, которая лежит ПОВЕРХ страницы. На боевом шаблоне (Bitrix,
     * cartilox.itsft.ru) шапка #header сначала absolute, а после прокрутки
     * получает класс .fixed и прилипает к верху — с нулевым отступом она
     * закрывала верх блока, и казалось, что прокрутка «проезжает» дальше.
     * Локально шапки нет — отступ 0.
     */
    const getHeaderOffset = function () {
        const header = document.querySelector(".js-header, #header, header.header, .page-header");

        if (!header) {
            return 0;
        }

        const position = window.getComputedStyle(header).position;

        if (position !== "fixed" && position !== "absolute" && position !== "sticky") {
            return 0;
        }

        return header.offsetHeight;
    };

    ResponsiveScroll.prototype.scrollTo = function (hash, extraOffset) {
        const RESPONSIVE_SCROLL = this;
        const wrapper = document.querySelector('.l-wrapper');
        const wrapperCurHeight = wrapper.clientHeight;
        const delayCheck = RESPONSIVE_SCROLL.duration * 1000 / 2;

        const doScroll = function() {
            gsap.to(window, {
                duration: RESPONSIVE_SCROLL.duration,
                scrollTo: {
                    y: hash,
                    offsetY: getHeaderOffset() + (extraOffset || 0)
                }
            })
        }

        doScroll();

        // setTimeout(() => {
        //     // В середине прокрутки проверяем, не изменилась ли высота у страницы,
        //     //  т.к есть ленивая загрузка скриптов и контент может прыгать, 
        //     // из-за этого может не доскролить до блока
        //     // если изменилась, скроллим еще раз
        //     if (wrapperCurHeight !== wrapper.clientHeight) {
        //         doScroll();
        //     }
        // }, delayCheck);
    }

    ResponsiveScroll.prototype.onLinkClick = function (evt) {
        evt.preventDefault();
        const RESPONSIVE_SCROLL = this;
        const target = evt.currentTarget;
        const hash = target.getAttribute("href");

        let extraOffset = 0;

        if (!itsoftApp.libraries.scrollToPlugin.loaded) {
            // console.log(itsoftApp.libraries.scrollToPlugin.loaded, ' if')
            new itsoftApp.modules.startLoad.callback(function () {
                RESPONSIVE_SCROLL.scrollTo(hash, extraOffset);
            }, itsoftApp.libraries.scrollToPlugin);
        } else {
            RESPONSIVE_SCROLL.scrollTo(hash, extraOffset);
            // console.log(itsoftApp.libraries.scrollToPlugin.loaded, ' else')
        }
    }

    ResponsiveScroll.prototype.init = function () {
        const RESPONSIVE_SCROLL = this;

        /*
         * На Bitrix сборка с 23.10.2026 грузится на всех страницах (шапка), а у страниц
         * старого шаблона нет .l-wrapper: там модуль отменял переход по любому якорю
         * («Подробнее» → #videos на /exercise) и падал на wrapper.clientHeight. На них
         * якоря работают как раньше — переходом браузера и обработчиками main-new.js.
         */
        if (!document.querySelector(".l-wrapper")) {
            return;
        }

        if (hash && hashElement) {
            new itsoftApp.modules.startLoad.callback(function () {
                RESPONSIVE_SCROLL.scrollTo(hash);
            }, itsoftApp.libraries.scrollToPlugin);
        }

        const links = document.querySelectorAll("a[href^='#']:not([href='#'])");

        /* Проходимся по всем элементам, у которых в href есть хэш */
        Array.prototype.forEach.call(links, function (link) {
            // const clickedScrollFlag = true;
            link.addEventListener("click", RESPONSIVE_SCROLL.onLinkClick.bind(RESPONSIVE_SCROLL));
        });
    }

    itsoftApp.modules.pageLoad.addEvent(function () {
        new ResponsiveScroll();
    });

    module.callback = ResponsiveScroll;
});